package com.veldekar.components.srd.spells

import androidx.compose.runtime.Composable
import com.veldekar.components.srd.SpellComponent
import com.veldekar.components.srd.SpellMetadata

@Composable
public fun SendingMetadata() {
    SpellMetadata(
        spellIndex = "sending",
        castingTime = "1 action",
        range = "Unlimited",
        components = listOf(SpellComponent.VERBAL, SpellComponent.SOMATIC, SpellComponent.MATERIAL),
        material = "A short piece of fine copper wire.",
        duration = "1 round",
        damageBase = null,
        damageScaling = null,
        savingThrow = null,
        aoe = null,
        concentration = false
    )
}
